import { Observable } from 'rxjs';
import { MatPaginator, MatSort } from '@angular/material';
import { SelectionChange, SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { GridViewColumnDefinition } from '@ui/grid-view/grid-view/grid-view.component';
import { GridDataSource } from '@ui/grid-view/grid-data.source';

export abstract class GridDataBase<T> implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() templates = {};
  @Input() showSelectColumn = false;

  @Output() selected = new EventEmitter<T[]>();

  dataSource$: GridDataSource<T> = null;
  displayedColumns: string[] = [];
  columns: GridViewColumnDefinition[] = [];
  selection: SelectionModel<T> = null;
  observableSelected: Observable<SelectionChange<T>> = null;
  loading = false;
  pageSizeOptions = [10, 20, 50];

  @Input()
  get definition() {
    return this.columns;
  }

  set definition(definition: GridViewColumnDefinition[]) {
    this.columns = definition;
  }

  @Input()
  get dataSource(): GridDataSource<T> {
    return this.dataSource$;
  }

  set dataSource(data: GridDataSource<T>) {
    this.dataSource$ = data;

    if (this.paginator) {
      this.paginator.firstPage();
    }

    if (this.showSelectColumn && this.selection) {
      this.selection.clear();
    }
  }

  @Input() pagination = true;

  ngOnInit() {
    this.setupDisplayColumn();
  }

  ngAfterViewInit() {
    this.initPaginationAndSort();

    setTimeout(() => {
      this.dataSource.loadData();
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  protected setupDisplayColumn() {
    this.displayedColumns = this.columns.map(x => x.definition);

    if (this.showSelectColumn) {
      this.selection = new SelectionModel<T>(true, []);
      this.observableSelected = this.selection.onChange.asObservable();
      this.displayedColumns.unshift('select');

      this.observableSelected.subscribe((change) => {
        this.selected.emit(change.source.selected);
      });
    }
  }

  protected initPaginationAndSort() {
    if (this.pagination) {
      this.dataSource.paginator = this.paginator;
    }

    this.dataSource.sort = this.sort;
  }
}
